module.exports = __webpack_public_path__ + "static/img/faq_about01.8a7fd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_about01.png
// module id = 39bG
// module chunks = 2